import _ from 'lodash'

type TeamAccountRow = {
  owner?: string | null
  owner_id?: string | number | null
  created_time?: string | number | null
}

export const getOwnerId = (
  user: { id?: string | number } | null | undefined,
  teamAccounts: TeamAccountRow[] | null | undefined
): string | number | null => {
  if (!user || !teamAccounts) return null
  if (teamAccounts.length === 0) return user.id ?? null

  // i.e. First person ever invited must be invited by the owner user
  const sortedTeamAccounts = _.sortBy(teamAccounts, ['created_time'])
  return sortedTeamAccounts[0]?.owner_id ?? null
}

/** Org workspace accounts own integrations separately from the home/personal account. */
export function isOrganizationWorkspaceUser(user: {
  is_organization_workspace?: boolean
  is_workspace_context?: boolean
} | null | undefined): boolean {
  if (!user) return false
  return !!(user.is_organization_workspace || user.is_workspace_context)
}

const WORKSPACE_EMAIL_SUFFIX = '@workspace.payhelm'

/** Drop org-membership share rows that can pollute personal Integrations owner resolution. */
export function filterClassicTeamAccountsForIntegrationsOwnerId<
  T extends { owner?: string | null; owner_id?: string | number | null }
>(teamAccounts: T[] | null | undefined): T[] {
  if (!Array.isArray(teamAccounts) || teamAccounts.length === 0) return []
  return teamAccounts.filter((row): row is T => {
    if (!row) return false
    const ownerEmail = String(row.owner || '').toLowerCase()
    return !ownerEmail.endsWith(WORKSPACE_EMAIL_SUFFIX)
  })
}

/** Integration key/secret owner id for the active session (org workspace uses user.id only). */
export function resolveIntegrationsOwnerId(
  user: { id?: string | number; is_organization_workspace?: boolean; is_workspace_context?: boolean } | null | undefined,
  teamAccounts: TeamAccountRow[] | null | undefined
): string | number | null {
  if (!user?.id) return null
  if (isOrganizationWorkspaceUser(user)) return user.id
  return getOwnerId(user, filterClassicTeamAccountsForIntegrationsOwnerId(teamAccounts))
}
